import { useLazyQuery } from "@apollo/client";
import { useCallback } from "react";
import { GET_FILE_UPLOAD_URL } from "../graphql/mutation/User";

const useFileUpload = () => {
  const [getFileUploadUrl, { loading }] = useLazyQuery(GET_FILE_UPLOAD_URL, {
    fetchPolicy: "network-only",
  });

  const uploadFile = useCallback(
    async ({ file, isPublic = false }) => {
      const res = await getFileUploadUrl({
        variables: {
          input: { filename: file.name, isPublic },
        },
      });

      const { success, uploadUrl, url, filename, error } =
        res?.data?.getFileUploadUrl ?? {};

      if (!success || !uploadUrl) {
        return { success: false, error };
      }

      await fetch(uploadUrl, {
        method: "PUT",
        body: file,
      });

      return { success: true, url, filename };
    },
    [getFileUploadUrl],
  );

  return { uploadFile, loading };
};

export default useFileUpload;
